import React, { memo, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useMap } from 'react-leaflet';
import { Slider } from '@progress/kendo-react-inputs';
import L from 'leaflet';

const CustomZoomControl = memo(() => {
  const map = useMap();
  const [zoom, setZoom] = useState(map.getZoom());
  const controlContainer = useRef(L.DomUtil.create('div'));

  useEffect(() => {
    const onZoomEnd = () => {
      const zoomlevel = map.getZoom()
      const layersKeys = _.entries(map._layers).filter(x => x[1]?._latlng != undefined).map(p => p[0]);
      for (const key of layersKeys) {
        const layer = map._layers[key];
        if (layer?.getIcon && layer?.getIcon()?.options?.iconSize) {
          let newIcon = layer.getIcon()
          newIcon.options.iconSize = [20 + (zoomlevel * 1.5), 21 + (zoomlevel * 1.5)]
          newIcon.options.className = ('custom-marker' + zoomlevel)
          layer.setIcon(newIcon)
        }
      }

      setZoom(zoomlevel);
    };

    map.on('zoomend', onZoomEnd);

    const CustomControl = L.Control.extend({
      onAdd: function () {
        return controlContainer.current;
      },
    });

    const control = new CustomControl({ position: 'topright' });
    control.addTo(map);

    return () => {
      map.off('zoomend', onZoomEnd);
      control.remove();
    };
  }, [map]);

  const handleSliderChange = (e) => {
    map.setZoom(e.value);
  };

  return createPortal(
    <div className="custom-zoom-control">
      <button onClick={() => map.zoomIn()}>+</button>
      <Slider
        value={zoom}
        min={2}
        max={18}
        vertical
        onChange={handleSliderChange}
      />
      <button onClick={() => map.zoomOut()}>-</button>
    </div>,
    controlContainer.current
  );
});

export default CustomZoomControl;
